<app-modal-shell
  data-cy="ticket-mandate-holder-modal-title"
  [title]="'TICKETS.MANDATE_HOLDER_INFORMATION.TITLE'"
  [cancelLabel]="'SET_IBAN.BUTTONS.CANCEL'"
  [saveLabel]="'SET_IBAN.BUTTONS.OK'"
  [saveDisabled]="saveDisabled"
  (cancelClicked)="cancel()"
  (saveClicked)="save()">

  <app-mandate-holder-form [initialData]="initialValues"></app-mandate-holder-form>

</app-modal-shell>
